export function numDigits(num: number): number {
	return (Math.log10((num ^ (num >> 31)) - (num >> 31)) | 0) + 1;
}

export function cutLastDigit(num: number): number {
	return Math.floor(num / 1e1);
}

export function getQuery(url: string): any {
	const parsed = JSON.parse(
		'{"' +
		decodeURI(url)
			.replace(/\?/g, '')
			.replace(/"/g, '\\"')
			.replace(/&/g, '","')
			.replace(/=/g, '":"') +
		'"}'
	);
	Object.entries(parsed).forEach((entry: any) => {
		if (entry[1] === 'true') {
			parsed[entry[0]] = true;
		} else if (entry[1] === 'false') {
			parsed[entry[0]] = false;
		} else if (!isNaN(entry[1])) {
			parsed[entry[0]] = +entry[1];
		}
	});
	return parsed;
}

export function formatFloatingNumber(num: number, precision: number = 2): string {
	return num.toFixed(precision).replace(/\./g, ',');
}

export function isEnter(evt: any): boolean {
	return evt.key === 'Enter';
}
